module.exports = __webpack_public_path__ + "static/media/blog_img.0953290b.jpg";